module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/4/2-e1444ed68c8ad011259047d8c55354e3.jpg";